module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/kayakFeatured2.webp";